<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation?.default"
    [opened]="!isScreenSmall"
    class="dark custom-body-background print:hidden"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex w-full items-center p-4 sidebar-logo-wrapper">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <img class="w-full cursor-pointer" src="grimmorLogo.svg" routerLink="/dashboard" alt="Logo"/>
            </div>
        </div>
        <!-- User -->
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div class="mb-4 mt-2 flex h-16 flex-0 items-center justify-center pl-2 pr-6 opacity-12">
<!--            <img class="max-w-36" src="images/logo/logo-text-on-dark.svg" />-->
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="sticky top-0 bg-card z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <!-- Navigation toggle button -->
        <button (click)="toggleNavigation('mainNavigation')" mat-icon-button>
            <mat-icon class="text-black" [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <div class="header-breadcrumbs-wrapper">
        @if(parts?.length > 1){
            <p (click)="goBack(pageName)" class="cursor-pointer">{{firstPart}}</p> &nbsp;>&nbsp; <h1>{{restPart}}</h1>
        }@else {
            @if((pageName == 'Product Management' || pageName == 'Order Management' || pageName == 'Customer Management' || pageName == 'Dashboard' || pageName == 'Edit Product' || pageName == 'Collection Management' || pageName == 'Update Collection' || pageName == 'Inventory Management') && isPartner){
                <div class="flex shrink-0 items-center gap-3 client-management-head">
                <mat-form-field appearance="outline" class="custom-dropdown header-custom-dropdown">
                    <mat-select #brandVal (selectionChange)="brandFilter(brandVal.value)" [(ngModel)]="brandStatusValue">
                         <mat-option value="" >
                                All
                            </mat-option>
                        @for(brand of brandList; track brand){
                            <mat-option [value]="brand.brandId" >
                                {{brand.brandNameEn}}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                </div>
            } @else {
                <h1>{{pageName}}</h1>
            }
        } 
        </div>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
<!--            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>-->
            <div class="ml-auto flex items-center">
                <user [showAvatar]="false"></user>
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Grimmor &copy; {{currentYear}}</span>
    </div>-->
</div>

